import { getImagesArray } from '../../hooks/useImagesArray';
import { ViewsAndLayoutsWrapper } from './styles';

import ViewsAndLayoutsListItem from './ViewsAndLayoutsListItem';

const ViewsAndLayouts = ({ images }) => {
  const { imageArray } = getImagesArray(images || [], 10);

  return (
    <ViewsAndLayoutsWrapper>
      {imageArray.slice(1, 7).map((image, index) => (
        <ViewsAndLayoutsListItem
          key={index}
          image={image}
        />
      ))}
    </ViewsAndLayoutsWrapper>
  );
};

export default ViewsAndLayouts;
